// InboxList (M1 §8): lista da inbox agregada com estado vazio localizado.
import { useTranslation } from 'react-i18next';

import type { WorkflowInboxItem } from '../api/contract.preview';
import { InboxItemCard } from './InboxItemCard';

export interface InboxListProps {
  readonly items: readonly WorkflowInboxItem[];
}

export function InboxList({ items }: InboxListProps) {
  const { t } = useTranslation('workflow');
  if (items.length === 0) {
    return (
      <div
        className="flex flex-col items-center gap-1 py-10 text-center"
        data-testid="inbox-list-empty"
      >
        <p className="font-medium">{t('inbox.empty')}</p>
        <p className="text-body text-muted-foreground">{t('inbox.emptyHint')}</p>
      </div>
    );
  }
  return (
    <ul className="flex flex-col gap-2" data-testid="inbox-list">
      {items.map((item) => (
        <InboxItemCard key={`${item.kind}-${item.id}`} item={item} />
      ))}
    </ul>
  );
}
